export default __webpack_public_path__ + "static/media/Blue-Android-2.9bf42121.png";